var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitationsFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98828 6.23145H1.98828V3.23145",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8883 4.11289C11.378 3.6019 10.7721 3.19652 10.105 2.91993C9.43794 2.64334 8.7229 2.50098 8.00078 2.50098C7.27866 2.50098 6.56362 2.64334 5.89656 2.91993C5.22951 3.19652 4.62353 3.6019 4.11328 4.11289L1.98828 6.23165",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0117 9.76855H14.0117V12.7686",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11328 11.8873C4.62353 12.3983 5.22951 12.8037 5.89656 13.0803C6.56362 13.3569 7.27866 13.4992 8.00078 13.4992C8.72291 13.4992 9.43795 13.3569 10.105 13.0803C10.7721 12.8037 11.378 12.3983 11.8883 11.8873L14.0133 9.76855",
    stroke: "#718096",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationsFull);
export default __webpack_public_path__ + "static/media/invitationsFull.4476655c.svg";
export { ForwardRef as ReactComponent };